<template>
  <div class="coupon-manage">
    <div class="content-wrapper">
      <div class="title-box">
        <span>店铺优惠券活动管理</span>
        <div class="search-box">
          <input v-model="form_data.keyword" type="text" placeholder="搜索优惠券信息" @keyup.enter="onSearch" />
          <img class="search-icon-btn" src="@/assets/images/icon-search.png" alt="" @click="onSearch" />
        </div>
      </div>

      <div class="tool-bar-box">
        <div class="filter-box">
          <div class="left">
            <span class="filter-label">状态：</span>
            <div class="filter-item-value-box">
              <div
                v-for="tab in statusTabs"
                :key="tab.value"
                class="filter-item"
                :class="{ active: form_data.status === tab.value }"
                @click="handleFilter('status', tab.value)"
              >
                <span>{{ tab.label }}</span>
                <span :class="{ warn: tab.value === 'pause' }">{{ statusCount[tab.value] }}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <span class="select-desc">已选{{ checked_list.length }}条</span>
            <div class="batch-delete-btn" :class="{ disabled: !checked_list.length }" @click="handleBatchDelete">批量删除</div>
            <div class="create-btn" @click="handleCreate">+ 新建优惠券</div>
          </div>
        </div>
      </div>

      <div class="table-box">
        <table>
          <colgroup>
            <col style="width: 50px;" />
            <col style="width: 180px;" />
            <col style="width: 170px;" />
            <col style="width: 280px;" />
            <col style="width: 100px;" />
            <col style="width: 100px;" />
            <col style="width: 150px;" />
            <col style="width: 60px;" />
            <col style="width: 140px;" />
          </colgroup>
          <thead>
            <tr>
              <th style="width: 50px;">
                <div class="col-check">
                  <Checkbox :indeterminate="indeterminate" :value="checkAll" @on-change="handleCheckAll"></Checkbox>
                </div>
              </th>
              <th style="width: 180px;">优惠券信息</th>
              <th style="width: 170px;">优惠内容</th>
              <th style="width: 280px;">活动/使用时间</th>
              <th style="width: 280px;">领券截止时间</th>
              <th style="width: 100px;">限领次数</th>
              <th style="width: 150px;">发放量/领取量/核销量</th>
              <th style="width: 60px;">状态</th>
              <th style="width: 140px;">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in coupon_list" :key="item.id">
              <td style="width: 50px;">
                <div class="col-check">
                  <Checkbox
                    :value="checked_list.includes(item.id)"
                    @on-change="(val) => handleSingleCheck(val, item.id)"
                  ></Checkbox>
                </div>
              </td>
              <td style="width: 180px;">
                <Tooltip placement="top" max-width="320">
                  <div class="col-coupon-info">
                    <div class="coupon-name">{{ item.name }}</div>
                    <div class="coupon-tag">{{ couponTag(item) }}</div>
                  </div>
                  <div slot="content">{{ item.name }}</div>
                </Tooltip>
              </td>
              <td style="width: 170px;">
                <div class="col-content">
                  <div class="content-title">{{ formatContent(item) }}</div>
                  <div class="content-sub">{{ formatScope(item) }}</div>
                </div>
              </td>
              <td style="width: 280px;">
                <Tooltip placement="top" max-width="320">
                  <div class="col-time">
                    <div class="time-row"><span class="tag">活动</span>{{ buildReceiveTimeText(item) }}</div>
                    <div class="time-row"><span class="tag">使用</span>{{ buildUseTimeText(item) }}</div>
                  </div>
                  <div slot="content">
                    <div>活动时间：{{ buildReceiveTimeText(item) }}</div>
                    <div>使用时间：{{ buildUseTimeText(item) }}</div>
                  </div>
                </Tooltip>
              </td>
              <td style="width: 100px;">
                <div class="col-limit">{{ item.take_before_time }}</div>
              </td>
              <td style="width: 100px;">
                <div class="col-limit">{{ item.take_limit_num > 0 ? item.take_limit_num + '张' : '不限' }}</div>
              </td>
              <td style="width: 170px;">
                <div class="col-count">
                  <div class="count-text">{{ item.release_num_type === 0 ? '∞' : item.release_num }}/<span class="red-text">{{ item.take_num }}</span>/{{ item.verify_num }}</div>
                  <div v-if="canAppend(item)" class="append-link" @click="openAppendModal(item)">追加发放量</div>
                </div>
              </td>
              <td style="width: 90px;">
                <div class="col-status">
                  <div class="status-text" :class="statusClass(item)">{{ statusText(item) }}</div>
                </div>
              </td>
              <td style="width: 140px;">
                <div class="col-action">
                  <span v-if="displayStatus(item) === STATUS.ONGOING" class="action-btn" @click="openConfirm(item, 'pause')">暂停</span>
                  <span v-if="displayStatus(item) === STATUS.PAUSED" class="action-btn" @click="handleStart(item)">恢复</span>
                  <span v-if="[STATUS.NOT_START, STATUS.PAUSED].includes(displayStatus(item))" class="action-btn" @click="handleEdit(item)">编辑</span>
                  <span class="action-btn" @click="handleDetail(item)">详情</span>
                  <span v-if="displayStatus(item) === STATUS.NOT_START" class="action-btn" @click="openConfirm(item, 'delete')">删除</span>
                </div>
              </td>
            </tr>
            <tr v-if="!coupon_list.length">
              <td colspan="8">
                <div class="empty-box">暂无数据</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="page-container">
      <Page :total="total_count" size="small" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
    </div>

    <!-- 新建/编辑/详情优惠券弹窗 -->
    <CouponEditModal :visible.sync="editModalVisible" :edit_id="edit_id" :readonly="editReadonly" @confirm="onEditConfirm" />
    <!-- 暂停/结束/删除 确认弹窗 -->
    <CouponConfirmModal :visible.sync="confirmModalVisible" :type="confirmType" @confirm="onConfirmAction" />
    <!-- 追加发放量弹窗 -->
    <CouponAddQuotaModal :visible.sync="addQuotaVisible" :coupon="currentCoupon" @confirm="onAddQuotaConfirm" />
  </div>
</template>

<script>
import CouponEditModal from "./components/couponEditModal.vue";
import CouponConfirmModal from "./components/couponConfirmModal.vue";
import CouponAddQuotaModal from "./components/couponAddQuotaModal.vue";
import { mapState } from "vuex";
import util from "@/utils/util";
import {
  GetShopCouponList,
  GetShopCouponDetail,
  CreateShopCoupon,
  UpdateShopCoupon,
  DeleteShopCoupon,
  PauseShopCoupon,
  ResumeShopCoupon,
  AddShopCouponReleaseNum,
  GetShopCouponCount,
  FinishShopCoupon,
} from "@/api/index";

// 优惠券活动状态（需与后端 Constant::SHOP_COUPON_STATUS_* 对齐）
const STATUS = {
  ONGOING: 1, // 进行中
  NOT_START: 0, // 未开始
  PAUSED: 3, // 已暂停
  ENDED: 2, // 已结束
};

export default {
  name: "ShopCouponManage",
  components: {
    CouponEditModal,
    CouponConfirmModal,
    CouponAddQuotaModal,
  },
  data() {
    return {
      util,
      STATUS,
      total_count: 0,
      coupon_list: [],
      indeterminate: false,
      checkAll: false,
      checked_list: [],
      form_data: {
        page: 1,
        limit: 10,
        status: "all",
        keyword: "",
      },
      statusCount: {
        all: 0,
        ing: 0,
        yet: 0,
        pause: 0,
        end: 0,
      },
      editModalVisible: false,
      edit_id: 0,
      editReadonly: false, // 详情查看模式（仅查看不可编辑）
      confirmModalVisible: false,
      confirmType: "", // pause | finish | delete
      currentCoupon: null,
      addQuotaVisible: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    statusTabs() {
      return [
        { value: "all", label: "全部" },
        { value: "ing", label: "进行中" },
        { value: "yet", label: "未开始" },
        { value: "pause", label: "已暂停" },
        { value: "end", label: "已结束" },
      ];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.checked_list = [];
      this.indeterminate = false;
      this.checkAll = false;
      this.coupon_list = [];
      this.total_count = 0;
      this.form_data.page = 1;
      this.refresh();
    },
    refresh() {
      this.getList();
      this.onGetCount();
    },
    // 获取优惠券活动列表（真实接口）
    getList() {
      const params = {
        page: this.form_data.page,
        limit: this.form_data.limit,
        name: this.form_data.keyword,
        status: this.form_data.status === "all" ? "" : this.form_data.status,
      };
      GetShopCouponList(params)
        .then((res) => {
          const data = res.data || {};
          this.coupon_list = data.list || [];
          this.total_count = data.count || 0;
          this.onCheckChange();
        })
        .catch((err) => {
          this.coupon_list = [];
          this.total_count = 0;
          this.$Message.error((err && err.msg) || "优惠券列表加载失败");
        });
    },
    // 各状态分组统计（按搜索关键词 name 过滤），用于 tab 角标计数（直接使用接口字段 all/ing/yet/pause/end）
    onGetCount() {
      GetShopCouponCount({ name: this.form_data.keyword })
        .then((res) => {
          const data = (res && res.data) || {};
          this.statusCount = {
            all: data.all || 0,
            ing: data.ing || 0,
            yet: data.yet || 0,
            pause: data.pause || 0,
            end: data.end || 0,
          };
        })
        .catch((err) => {
          this.statusCount = {
            all: this.total_count,
            ing: 0,
            yet: 0,
            pause: 0,
            end: 0,
          };
          this.$Message.error((err && err.msg) || "优惠券统计加载失败");
        });
    },
    onPageChange(e) {
      this.form_data.page = e;
      this.getList();
    },
    handleSingleCheck(checked, id) {
      if (checked) {
        if (!this.checked_list.includes(id)) {
          this.checked_list.push(id);
        }
      } else {
        const index = this.checked_list.indexOf(id);
        if (index > -1) {
          this.checked_list.splice(index, 1);
        }
      }
      this.onCheckChange();
    },
    onCheckChange() {
      if (this.checked_list.length === 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else if (this.checked_list.length === this.coupon_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else {
        this.indeterminate = true;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      // 半选(indeterminate)时 checkAll 已为 false，点击表头应“全选”，而非清空
      const willCheckAll = !this.checkAll;
      this.checkAll = willCheckAll;
      this.indeterminate = false;
      this.checked_list = willCheckAll ? this.coupon_list.map((item) => item.id) : [];
    },
    onSearch() {
      this.init();
    },
    handleFilter(type, value) {
      this.form_data[type] = value;
      this.init();
    },
    // ===== 优惠内容/适用范围 文案格式化 =====
    formatContent(item) {
      // 后端 coupon_type: 1=满减, 2=折扣（立减在前端按满减门槛0处理）
      if (item.coupon_type === 1) {
        const threshold = util.formatNum(item.threshold);
        const discount = util.formatNum(item.discount);
        return Number(item.threshold) > 0 ? `满${threshold}减${discount}` : `立减${discount}`;
      }
      if (item.coupon_type === 2) return `打${util.formatNum(item.discount)}折`; // 折扣券
      return "-";
    },
    // 优惠券标签：适用范围为「全店通用」即店铺优惠券，否则为店铺商品券
    couponTag(item) {
      return item.product_condition === 0 ? "店铺优惠券" : "店铺商品券";
    },
    formatScope(item) {
      const scopeMap = { 0: "全店通用", 1: "指定商品可用", 2: "指定商品不可用" };
      // 券类型：满减券门槛为0显示「立减券」，否则「满减券」；折扣券为「折扣券」
      let typeLabel = "-";
      if (item.coupon_type === 1) {
        typeLabel = Number(item.threshold) > 0 ? "满减券" : "立减券";
      } else if (item.coupon_type === 2) {
        typeLabel = "折扣券";
      }
      return `${scopeMap[item.product_condition] || "-"}-${typeLabel}`;
    },
    // 展示状态：status=3 已暂停优先；status=2 已结束；否则按活动时间计算
    // 活动时间前=未开始，时间内=进行中，时间后=已结束；时间缺失则回退原始 status
    displayStatus(item) {
      if (item.status === STATUS.PAUSED) return STATUS.PAUSED;
      if (item.status === STATUS.ENDED) return STATUS.ENDED;
      const start = this.toTime(item.act_start_time);
      const end = this.toTime(item.act_end_time);
      if (start == null || end == null) return item.status;
      const now = Date.now();
      if (now < start) return STATUS.NOT_START;
      if (now > end) return STATUS.ENDED;
      return STATUS.ONGOING;
    },
    toTime(val) {
      if (!val) return null;
      const t = new Date(String(val).replace(/-/g, "/")).getTime();
      return isNaN(t) ? null : t;
    },
    statusText(item) {
      const map = { [STATUS.ONGOING]: "进行中", [STATUS.NOT_START]: "未开始", [STATUS.PAUSED]: "已暂停", [STATUS.ENDED]: "已结束" };
      return map[this.displayStatus(item)] || "-";
    },
    statusClass(item) {
      const map = { [STATUS.ONGOING]: "green", [STATUS.NOT_START]: "orange", [STATUS.PAUSED]: "red", [STATUS.ENDED]: "gray" };
      return map[this.displayStatus(item)] || "";
    },
    buildReceiveTimeText(item) {
      return this.fmtRange(item.act_start_time, item.act_end_time);
    },
    buildUseTimeText(item) {
      if (item.time_type === 0) return this.fmtRange(item.start_time, item.end_time);
      return "领券后" + (item.expire_days || 0) + "天内有效";
    },
    fmtRange(s, e) {
      const arr = [s, e].filter(Boolean);
      return arr.length ? arr.join(" - ") : "-";
    },
    // 是否显示追加发放量：展示状态为进行中/已暂停 且 发放量不是无限(release_num_type!==0)
    canAppend(item) {
      return [STATUS.ONGOING, STATUS.PAUSED].includes(this.displayStatus(item)) && item.release_num_type !== 0;
    },
    // ===== 新建/编辑 =====
    handleCreate() {
      this.edit_id = 0;
      this.editReadonly = false;
      this.editModalVisible = true;
    },
    handleEdit(item) {
      this.edit_id = item.id;
      this.editReadonly = false;
      this.editModalVisible = true;
    },
    // 详情：只读查看，不可编辑
    handleDetail(item) {
      this.edit_id = item.id;
      this.editReadonly = true;
      this.editModalVisible = true;
    },
    onEditConfirm() {
      this.refresh();
    },
    // ===== 开始（未开始/已暂停 -> 进行中，对应后端 resume 恢复） =====
    handleStart(item) {
      ResumeShopCoupon({ id: item.id })
        .then(() => {
          this.$Message.success("活动已开始");
          item.status = STATUS.ONGOING;
        })
        .catch((err) => {
          this.$Message.error((err && err.msg) || "活动开始失败");
        });
    },
    // ===== 暂停/结束/删除 确认弹窗 =====
    openConfirm(item, type) {
      this.currentCoupon = item;
      this.confirmType = type;
      this.confirmModalVisible = true;
    },
    onConfirmAction() {
      // 批量删除不需要单条 item（currentCoupon 为 null），单独处理，避免被下方 !item 守卫拦截
      if (this.confirmType === "batch_delete") {
        if (!this.checked_list.length) return;
        DeleteShopCoupon({ ids: this.checked_list })
          .then(() => {
            this.$Message.success("已删除");
            this.coupon_list = this.coupon_list.filter((row) => !this.checked_list.includes(row.id));
            this.checked_list = [];
            this.onCheckChange();
          })
          .catch((err) => {
            this.$Message.error((err && err.msg) || "批量删除失败");
          });
        this.currentCoupon = null;
        return;
      }

      const item = this.currentCoupon;
      if (!item) return;
      const id = item.id;
      if (this.confirmType === "pause") {
        PauseShopCoupon({ id })
          .then(() => {
            this.$Message.success("已暂停");
            item.status = STATUS.PAUSED;
          })
          .catch((err) => {
            this.$Message.error((err && err.msg) || "暂停失败");
          });
      } else if (this.confirmType === "finish") {
        FinishShopCoupon({ id })
          .then(() => {
            this.$Message.success("已结束");
            item.status = STATUS.ENDED;
          })
          .catch((err) => {
            this.$Message.error((err && err.msg) || "结束失败");
          });
      } else if (this.confirmType === "delete") {
        DeleteShopCoupon({ id })
          .then(() => {
            this.$Message.success("已删除");
            this.coupon_list = this.coupon_list.filter((row) => row.id !== id);
            this.checked_list = this.checked_list.filter((x) => x !== id);
            this.onCheckChange();
          })
          .catch((err) => {
            this.$Message.error((err && err.msg) || "删除失败");
          });
      }
      this.currentCoupon = null;
    },
    handleBatchDelete() {
      if (!this.checked_list.length) return;
      this.currentCoupon = null;
      this.confirmType = "batch_delete";
      this.confirmModalVisible = true;
    },
    // ===== 追加发放量 =====
    openAppendModal(item) {
      this.currentCoupon = item;
      this.addQuotaVisible = true;
    },
    // 追加发放量成功后回调（payload: { id, add_count }）
    onAddQuotaConfirm({ id, add_count }) {
      AddShopCouponReleaseNum({ id, add_num: add_count })
        .then((res) => {
          const newNum = res.data && res.data.release_num;
          const item = this.coupon_list.find((row) => row.id === id);
          if (item) {
            item.release_num = newNum != null ? newNum : item.release_num + add_count;
          }
          this.$Message.success("追加成功");
          this.currentCoupon = null;
        })
        .catch((err) => {
          this.$Message.error((err && err.msg) || "追加发放量失败");
          this.currentCoupon = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-manage {
  width: 100%;
  height: 100%;

  .content-wrapper {
    margin-top: 10px;
    padding: 24px 30px 20px 30px;
    background: #ffffff;
    line-height: 1.5;
    font-size: 14px;

    .title-box {
      width: 100%;
      border-bottom: 1px solid #d6d6d6;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        padding-bottom: 17px;
        border-bottom: 3px solid #ff5967;
      }

      .search-box {
        background: #f3f4f6;
        border-radius: 24px;
        display: flex;
        align-items: center;
        padding: 10px 20px;
        width: 280px;

        input {
          border: none;
          outline: none;
          background: transparent;
          flex: 1;
          padding-right: 10px;
        }

        .search-icon-btn {
          width: 22px;
          height: 22px;
          margin-left: 4px;
          cursor: pointer;
        }
      }
    }

    .tool-bar-box {
      margin-top: 20px;

      .filter-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          align-items: center;
          gap: 10px;

          .filter-label {
            font-size: 14px;
            color: #333333;
          }

          .filter-item-value-box {
            display: flex;
            align-items: center;
            gap: 10px;
            height: 41px;
            padding: 4px;
            background: #f5f6f8;
            border-radius: 8px;
          }

          .filter-item {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 6px 12px;
            cursor: pointer;

            &.active {
              color: #ff5967;
              background: #ffffff;
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          gap: 10px;

          .select-desc {
            font-size: 14px;
            color: #666666;
          }

          .batch-delete-btn {
            width: 104px;
            height: 40px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #ff5967;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            color: #ff5967;

            &:hover {
              opacity: 0.9;
            }

            &.disabled {
              border-color: #e3e3e3;
              color: #999999;
              cursor: not-allowed;
            }
          }

          .create-btn {
            height: 40px;
            padding: 0 20px;
            background: #ff5967;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            color: #ffffff;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }
    }

    .table-box {
      margin-top: 20px;
      width: 100%;
      overflow: auto;

      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          background: #f6f7fa;
          height: 56px;
          color: #666666;

          tr {
            border: 1px solid #e3e3e3;
            th {
              vertical-align: middle;
              padding: 10px;
              overflow: hidden;
              text-align: left;
              font-weight: 400;
            }
          }
        }

        tbody {
          tr {
            border: 1px solid #e3e3e3;

            td {
              vertical-align: middle;
              padding: 10px;
              overflow: hidden;

              .col-check {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                padding: 12px;

                ::v-deep .ivu-checkbox-group-item,
                .ivu-checkbox-wrapper-checked {
                  border-spacing: 0;

                  span {
                    &:nth-child(2) {
                      display: none;
                    }
                  }
                }
              }

              .col-coupon-info {
                .coupon-name {
                  font-size: 14px;
                  color: #333333;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .coupon-tag {
                  margin-top: 4px;
                  display: inline-block;
                  padding: 1px 5px;
                  border: 1px solid #ff5967;
                  border-radius: 4px;
                  font-size: 12px;
                  color: #ff5967;
                }
              }

              .col-content {
                .content-title {
                  font-size: 14px;
                  color: #333333;
                }

                .content-sub {
                  margin-top: 6px;
                  color: #999999;
                }
              }

              .col-time {
                .time-row {
                  font-size: 14px;
                  color: #333333;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;

                  & + .time-row {
                    margin-top: 4px;
                  }
                  .tag {
                    margin-right: 12px;
                    padding: 0 4px;
                    height: 21px;
                    background: #F8F9FB;
                    border-radius: 2px 2px 2px 2px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                  }
                }
              }

              .col-limit {
                font-size: 14px;
                color: #333333;
              }

              .col-count {
                .count-text {
                  font-size: 14px;
                  color: #333333;
                }

                .red-text {
                  color: #ff5967;
                }

                .append-link {
                  margin-top: 4px;
                  font-size: 12px;
                  color: #0d99ff;
                  cursor: pointer;

                  &:hover {
                    text-decoration: underline;
                  }
                }
              }

              .col-status {
                .status-text {
                  font-size: 14px;

                  &.green {
                    color: #02c160;
                  }

                  &.orange {
                    color: #ff5000;
                  }
                  &.red {
                    color: #ff5967;
                  }

                  &.gray {
                    color: #999999;
                  }
                }
              }

              .col-action {
                display: flex;
                flex-wrap: wrap;
                gap: 8px 14px;

                .action-btn {
                  font-size: 14px;
                  color: #0D99FF;
                  cursor: pointer;

                  &:hover {
                    color: #0D9FFD;
                  }
                }
              }

              .empty-box {
                text-align: center;
                padding: 40px 0;
                font-size: 14px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
}

.page-container {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
}

.warn {
  color: #ff5000 !important;
}
</style>
